import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '../views/Home'
import Wildcard from '../views/Wildcard'
import Search from '../views/Search'
/*! scaffold:import:route */

Vue.use(Meta)
Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active-exact',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      alias: '/home',
      component: Home
    },
    {
      path: '/en',
      name: 'HomeEnglish',
      alias: '/en/home',
      component: Home
    },
    /*! scaffold:insert:route */
    {
      path: '/suchen',
      alias: '/en/search',
      name: 'Search',
      component: Search
    },
    {
      path: '*',
      alias: '/en/*',
      name: 'Wildcard',
      component: Wildcard
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js